import exchangeInfo from '../widgets/exchangeInfo.js';

(function ($) {
    $(async function () {
        window.$ = jQuery;
        await exchangeInfo.updateDynamicsData();
    });
}(jQuery));